import DishesData from './DishesData'
import useDishesData from './useDishesData'
import { SaveType, Photo } from './useDishes'


export default DishesData
export { useDishesData }
export type { SaveType, Photo }
